import React, { useEffect } from "react";


// import LanguageTranslate from "./LanguageTranslate";

function HeaderUser() {

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-md-12">
          <div className="translator-holder">
            <div className="logo">
              <img
                src="https://res.cloudinary.com/sparkcloudsforewards/image/upload/v1718344862/logo_l667oi.png"
                alt="city-logo.png"
                className="img-fluid"
                width="360"
                height="118"
              />
            </div>
            {/* <LanguageTranslate /> */}
          </div>
        </div>
        <div className="fix-white"></div>
      </div>
    </div>
  );
}
export default HeaderUser;
